import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const PersonalDetailsRequestAction = createAction('[Personal details] get data', props<{ accountId: number }>());
export const PersonalDetailsResponseAction = createAction('[Personal details] set data', props<{ wording: { [key: string]: string } }>());